import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FormControl,
  Input,
  Button,
  InputAdornment,
  IconButton,
  Snackbar,
  Alert,
  AlertTitle,
  Box,
} from "@mui/material";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
// import { Prompt } from "react-router-dom";
import Table from "./Table";
import moment from "moment";
import { mapData } from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import "./freeFrom.scss";
import {
  dataEntry,
  getProDataForReset,
  rejectData,
  setOCRValue,
} from "../../../redux/processor/actions";
import {
  rejectValidatorData,
  validateData,
} from "../../../redux/validator/actions";
import Authentication from "../../Modal/PopupModal/PopupModal";
import ModalSign from "../../Modal/Signature/ModalSign";
import { logObject } from "../../../config/logs";
// import { Prompt } from "../../Prompt";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.2rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }

      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }
`;

const headerAlphabetString = (num) => {
  let s = "";
  let t = null;

  while (num > 0) {
    t = (num - 1) % 26;
    s = String.fromCharCode(65 + t) + s;
    num = ((num - t) / 26) | 0;
  }
  return s || "";
};

const CNCTableWrapper = React.forwardRef((props, ref) => {
  const {
    selectedFile,
    selectedArea,
    role,
    parametersData: parametersDataFromState,
    columnsCount: countOfColumns,
    reProcess,
    reValidate,
    areaIndex,
    isDataRejectedByProcessor,
    isDataRejectedByValidator,
    showContextMenu,
    isDisableOnChangeInput,
    isDisableOnBlur,
    // isFullView,
    resetPdfHeighlights,
    entireBatchRejectedByPro,
    entireBatchRejectedByVali,
    reProcessEntireBatch,
    resestSelectedArea,
    showParameterTable,
  } = props;
  const dispatch = useDispatch();
  let initialRowsData;

  if (parametersDataFromState.length > 0) {
    initialRowsData = parametersDataFromState;
  } else {
    initialRowsData = [{}, {}, {}, {}, {}];
  }
  const bindOcrValuesAndCoords = useSelector(
    (state) => state?.pro?.bindOcrValuesAndCoords
  );
  const selectedFilesDataForProUpdate = useSelector(
    (state) => state?.pro?.selectedFilesDataForProUpdate
  );

  const coordinatesData = useSelector((state) => {
    if (role === "preProcessor") {
      return state?.prePro?.coorData?.coordinatesDetails;
    } else if (role === "processor") {
      return state?.pro?.coorData?.coordinatesDetails;
    } else if (role === "validator") {
      return state?.vali?.coorData?.coordinatesDetails;
    }
  });

  const [skipPageReset, setSkipPageReset] = useState(false);
  const [rowsData, setRowsData] = useState(initialRowsData);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [columnsCount, setColumnsCount] = useState(
    countOfColumns ? countOfColumns : 5
  );
  const anyOperationPerformedOnEntirePage = React.useRef(false);
  const [cellToUpdate, setCellToUpdate] = useState({
    rowIndex: null,
    columnId: null,
  });
  const [isAlert, setAlert] = useState({
    open: false,
    message: "",
    title: "",
  });
  const [openAuth, setOpenAuth] = useState(false);
  const [openSignPad, setOpenSignPad] = useState(false);
  const rowInputRef = React.useRef();
  const colInputRef = React.useRef();
  const [toggleStateOnly, setToggleStateOnly] = useState(false);
  const [logs, setLogs] = useState([]);

  const handleCloseAuth = () => {
    setOpenAuth(false);
  };

  const handleCloseSignPad = () => {
    setOpenSignPad(false);
  };

  const handleUserPermission = () => {
    dispatch(
      validateData({
        parametersData: rowsData,
        batch_id: localStorage.batchId,
        projectId: localStorage.projectId,
        next: true,
        extractionType: "free-form",
        partially_validated: false,
        columnsCount: columnsCount,
        logs: logs,
      })
    );
  };
  React.useImperativeHandle(ref, () => ({
    mapData(
      action,
      remark,
      batchRejection,

      signUploaded
    ) {
      anyOperationPerformedOnEntirePage.current = false;
      setToggleStateOnly((prev) => !prev);
      if (action !== "save") {
        if (rejectedCount >= 1) {
          action = "reject";
        }
      }

      const next = action === "saveAndNext" ? true : false;
      const extractionType = "free-form";

      if (role === "preProcessor") {
        if (action === "saveAndNext") {
          if (processorsRejectionCounts) {
            setAlert({
              ...isAlert,
              open: true,
              message:
                "Some rejection are not resolved. please resolve them before continue.",
              title: "Resolve Rejections",
            });
          } else
            dispatch(
              mapData({
                parametersData: rowsData,
                projectId: localStorage.projectId,
                next: next,
                extractionType: extractionType,
                isUpdateParameters: false,
                isDataRejectedByProcessor: false,
                ...(isDataRejectedByProcessor && {
                  reProcess: true,
                }),
                ...(isDataRejectedByValidator && {
                  isDataRejectedByValidator: true,
                }),
                entireBatchRejectedByPro: false,
                ...(entireBatchRejectedByPro && {
                  reProcessEntireBatch: true,
                }),
                columnsCount: columnsCount,
                logs: logs,
                processorsRejectionCounts: processorsRejectionCounts,
                validatorsRejectionCounts: validatorsRejectionCounts,
              })
            );
        }
        if (action === "save") {
          dispatch(
            mapData({
              parametersData: rowsData,
              projectId: localStorage.projectId,
              next: next,
              extractionType: extractionType,
              isUpdateParameters: false,
              ...(isDataRejectedByProcessor && {
                isDataRejectedByProcessor: true,
              }),
              ...(isDataRejectedByValidator && {
                isDataRejectedByValidator: true,
              }),
              ...(entireBatchRejectedByPro && {
                entireBatchRejectedByPro: true,
              }),
              columnsCount: columnsCount,
              logs: logs,
              processorsRejectionCounts: processorsRejectionCounts,
              validatorsRejectionCounts: validatorsRejectionCounts,
            })
          );
          setLogs([]);
        }
      }

      if (role === "processor") {
        if (action === "reject") {
          dispatch(
            rejectData({
              parametersData: rowsData,
              batch_id: localStorage.batchId,
              next: next,
              extractionType: extractionType,
              ...(isDataRejectedByValidator && {
                isDataRejectedByValidator: true,
              }),
              rejection_remark: remark,
              isDataRejectedByProcessor: true,
              projectId: localStorage.projectId,
              entireBatchRejectedByPro: batchRejection === true ? true : false,
              ...(entireBatchRejectedByVali && {
                entireBatchRejectedByVali: true,
              }),
              columnsCount: columnsCount,
              logs: logs,
              processorsRejectionCounts: processorsRejectionCounts,
              validatorsRejectionCounts: validatorsRejectionCounts,
            })
          );
        } else if (action === "save") {
          dispatch(
            dataEntry({
              parametersData: rowsData,
              batch_id: localStorage.batchId,
              next: next,
              extractionType: extractionType,
              ...(isDataRejectedByValidator && {
                isDataRejectedByValidator: true,
              }),
              partial_data_entry: true,
              ...(entireBatchRejectedByVali && {
                entireBatchRejectedByVali: true,
              }),
              ...(isDataRejectedByProcessor && {
                isDataRejectedByProcessor: true,
              }),
              ...(isDataRejectedByProcessor && {
                reProcess: true,
              }),
              ...(reProcessEntireBatch && {
                reProcessEntireBatch: true,
              }),
              columnsCount: columnsCount,
              logs: logs,
              processorsRejectionCounts: processorsRejectionCounts,
              validatorsRejectionCounts: validatorsRejectionCounts,
            })
          );
          setLogs([]);
        } else if (action === "saveAndNext") {
          if (validatorsRejectionCounts) {
            setAlert({
              ...isAlert,
              open: true,
              message:
                "Some rejection are not resolved. please resolve them before continue.",
              title: "Resolve Rejections",
            });
          } else
            dispatch(
              dataEntry({
                parametersData: rowsData,
                batch_id: localStorage.batchId,
                next: next,
                extractionType: extractionType,
                ...(isDataRejectedByValidator && {
                  reValidate: true,
                }),
                ...(isDataRejectedByValidator && {
                  isDataRejectedByValidator: true,
                }),
                partial_data_entry: false,
                entireBatchRejectedByVali: false,
                ...(entireBatchRejectedByVali && {
                  reValidateEntireBatch: true,
                }),
                columnsCount: columnsCount,
                logs: logs,
                processorsRejectionCounts: processorsRejectionCounts,
                validatorsRejectionCounts: validatorsRejectionCounts,
              })
            );
        }
      }

      if (role === "validator") {
        if (action === "reject") {
          dispatch(
            rejectValidatorData({
              parametersData: rowsData,
              batch_id: localStorage.batchId,
              next: next,
              extractionType: extractionType,
              rejection_remark: remark,
              isDataRejectedByValidator: true,
              projectId: localStorage.projectId,
              entireBatchRejectedByVali: batchRejection === true ? true : false,
              columnsCount: columnsCount,
              logs: logs,
              validatorsRejectionCounts: validatorsRejectionCounts,
            })
          );
        } else if (action === "saveAndNext") {
          let allValidatedData;
          if (rowsData) {
            allValidatedData = rowsData.every(
              (item) => item?.rowValidation?.isValidated
            );
          } else {
            allValidatedData = false;
          }

          if (allValidatedData) {
            if (signUploaded === false) {
              setOpenSignPad(true);
            } else if (signUploaded === true) {
              setOpenAuth(true);
            }
          } else {
            setAlert({
              ...isAlert,
              open: true,
              message:
                "Some fields are not validated. Please validate them before continuing.",
              title: "Validation Error",
            });
          }
        } else if (action === "save") {
          dispatch(
            validateData({
              parametersData: rowsData,
              batch_id: localStorage.batchId,
              projectId: localStorage.projectId,
              next: next,
              extractionType: extractionType,
              partially_validated: true,
              columnsCount: columnsCount,
              logs: logs,
              validatorsRejectionCounts: validatorsRejectionCounts,
            })
          );
          setLogs([]);
        }
      }
    },
  }));

  const roleMapping = {
    preProcessor: "prePro",
    processor: "pro",
    validator: "vali",
  };
  const useRejectionCounts = (role, rejectionType) => {
    const roleKey = roleMapping[role];
    return useSelector(
      (state) =>
        state?.[roleKey]?.coorData?.mapping_details?.[
          `${rejectionType}RejectionCounts`
        ] || 0
    );
  };
  const [processorsRejectionCounts, setProcessorsRejectionCounts] = useState(
    useRejectionCounts(role, "processors")
  );
  const [validatorsRejectionCounts, setValidatorsRejectionCounts] = useState(
    useRejectionCounts(role, "validators")
  );

  useEffect(() => {
    window.addEventListener("beforeunload", beforeunloadFunc);

    return () => {
      // Anything in here is fired on component unmount.
      window.removeEventListener("beforeunload", beforeunloadFunc);
    };
  }, []);

  const addInitialColumns = () => {
    const emptyColumns = [];
    for (let i = 0; i < 5; i++) {
      emptyColumns.push({
        accessor: `col${i + 1}`,
        Header: headerAlphabetString(i + 1),
      });
    }
    setColumns([...emptyColumns]);
  };

  useEffect(() => {
    if (countOfColumns && countOfColumns > 0) {
      for (let i = 0; i < countOfColumns; i++) {
        columns.push({
          accessor: `col${i + 1}`,
          Header: headerAlphabetString(i + 1),
        });
      }
      setColumns([...columns]);
    } else {
      // initially  adding 5 empty columns
      addInitialColumns();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countOfColumns]);

  const beforeunloadFunc = (e) => {
    if (anyOperationPerformedOnEntirePage.current) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  useEffect(() => {
    if (bindOcrValuesAndCoords?.coords && bindOcrValuesAndCoords?.value) {
      updateCell(bindOcrValuesAndCoords);
      dispatch(setOCRValue());

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
      setSkipPageReset(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bindOcrValuesAndCoords]);

  const updateCell = (bindOcrValuesAndCoords) => {
    if (cellToUpdate?.rowIndex >= 0 && cellToUpdate?.columnId) {
      var transformedHashToNumber = bindOcrValuesAndCoords?.value?.replace(
        "#",
        "Number"
      );
      if (
        rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId] &&
        rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId].value !==
          bindOcrValuesAndCoords?.value
      ) {
        var transformedValue = `${
          rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId].value
        } ${transformedHashToNumber}`.trim();
      } else {
        transformedValue = `${transformedHashToNumber}`.trim();
      }

      rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId] = {
        ...rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId],
        value: transformedValue,

        coordinates:
          rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]
            ?.coordinates &&
          rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]?.coordinates
            ?.length >= 0
            ? [
                ...rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]
                  ?.coordinates,
                bindOcrValuesAndCoords?.coords,
              ]
            : [bindOcrValuesAndCoords?.coords],

        coordinatesValues:
          rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]
            ?.coordinatesValues &&
          rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]
            ?.coordinatesValues?.length >= 0
            ? [
                ...rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId]
                  ?.coordinatesValues,
                bindOcrValuesAndCoords?.value,
              ]
            : [bindOcrValuesAndCoords?.value],

        processor: localStorage.userRole,
        processedDate: moment(new Date()).format("DD-MMM-YYYY"),
      };
      let cellData = rowsData[cellToUpdate?.rowIndex][cellToUpdate?.columnId];
      if (
        (cellData?.pageNo === "" ||
          cellData?.pageNo === undefined ||
          cellData?.pageNo === null) &&
        (cellData?.tagName === "" ||
          cellData?.tagName === undefined ||
          cellData?.tagName === null)
      ) {
        cellData = {
          ...cellData,
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
        };
      }

      setRowsData([...rowsData]);
    }
  };

  const setCellToUpdateToState = ({ rowIndex, columnId, mappingFor }) => {
    setCellToUpdate({
      // used for pre and pro role
      rowIndex: rowIndex,
      columnId: columnId,
      mappingFor: mappingFor,
    });
  };

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = ({ rowIndex, columnId, value, type, string }) => {
    // this func called from 2 location based on role wise and from one location which is pre pro we are not passing value
    // pre pro logs for mapping not inserted in this function as this calls when user click not onblur so onblur added function to store logs
    setSkipPageReset(true);
    if (role === "preProcessor") {
      // in pre-pro we are only saving mappings not value
      if (
        rowsData[rowIndex][columnId] === undefined ||
        rowsData[rowIndex][columnId]
      ) {
        if (string === "forParameterKey") {
          if (isDataRejectedByProcessor) {
            if (
              parseInt(selectedFile?.fileNo) !==
                parseInt(rowsData[rowIndex][columnId]?.fileNo) ||
              parseInt(selectedFile?.pageNo) !==
                parseInt(rowsData[rowIndex][columnId]?.pageNo) ||
              selectedFile?.tagName !== rowsData[rowIndex][columnId]?.tagName
            ) {
              rowsData[rowIndex][columnId] = {
                ...rowsData[rowIndex][columnId],
                keyCoordinates: [],
                keyCoordinatesValues: [],
              };

              rowsData[rowIndex][columnId]["keyData"] = {
                ...rowsData[rowIndex][columnId]["keyData"],
                value: "",
                ...selectedFile,
                preProcessor: localStorage?.userName,
                preProcessedDate: moment(new Date()).format("MM-DD-YYYY"),
                indexesOfCoordinates: [],
              };
            }
          } else {
            // Check if the row exists, if not, create it
            if (!rowsData[rowIndex]) {
              rowsData[rowIndex] = {};
            }

            // Check if the column exists, if not, create it
            if (!rowsData[rowIndex][columnId]) {
              rowsData[rowIndex][columnId] = {};
            }
            rowsData[rowIndex][columnId] = {
              ...rowsData[rowIndex][columnId],
              keyCoordinates: [],
              keyCoordinatesValues: [],
            };

            rowsData[rowIndex][columnId]["keyData"] = {
              value: "",
              ...selectedFile,
              preProcessor: localStorage?.userName,
              preProcessedDate: moment(new Date()).format("MM-DD-YYYY"),
              indexesOfCoordinates: [],
            };
          }
        } else {
          if (isDataRejectedByProcessor) {
            if (
              parseInt(selectedFile?.fileNo) !==
                parseInt(rowsData[rowIndex][columnId]?.fileNo) ||
              parseInt(selectedFile?.pageNo) !==
                parseInt(rowsData[rowIndex][columnId]?.pageNo) ||
              selectedFile?.tagName !== rowsData[rowIndex][columnId]?.tagName
            ) {
              rowsData[rowIndex][columnId] = {
                ...rowsData[rowIndex][columnId],
                value: "",
                ...selectedFile,
                coordinates: [],
                preProcessor: localStorage?.userName,
                preProcessedDate: moment(new Date()).format("MM-DD-YYYY"),
                indexesOfCoordinates: [],
                coordinatesValues: [],
              };
            }
          } else {
            if (
              rowsData[rowIndex][columnId]?.tagName &&
              rowsData[rowIndex][columnId]?.pageNo >= 0 &&
              (rowsData[rowIndex][columnId]?.tagName !==
                selectedFile?.tagName ||
                parseInt(rowsData[rowIndex][columnId]?.pageNo) !==
                  parseInt(selectedFile?.pageNo))
            ) {
              rowsData[rowIndex][columnId] = {
                ...rowsData[rowIndex][columnId],
                value: "",
                ...selectedFile,
                coordinates: [],
                coordinatesValues: [],
                preProcessor: localStorage?.userName,
                preProcessedDate: moment(new Date()).format("MM-DD-YYYY"),
              };

              rowsData[rowIndex][columnId]["rowColIndex"] = [
                parseInt(rowIndex) + 1,
                parseInt(columnId.match(/\d+/)[0]),
              ];
            } else {
              rowsData[rowIndex][columnId] = {
                ...rowsData[rowIndex][columnId],
                ...selectedFile,
                coordinates: rowsData[rowIndex][columnId]?.coordinates
                  ? rowsData[rowIndex][columnId]?.coordinates
                  : [],
                coordinatesValues: rowsData[rowIndex][columnId]
                  ?.coordinatesValues
                  ? rowsData[rowIndex][columnId]?.coordinatesValues
                  : [],
                preProcessor: localStorage?.userName,
                preProcessedDate: moment(new Date()).format("MM-DD-YYYY"),
              };

              rowsData[rowIndex][columnId]["rowColIndex"] = [
                parseInt(rowIndex) + 1,
                parseInt(columnId.match(/\d+/)[0]),
              ];
            }
          }
        }
        setRowsData([...rowsData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
      }
    }

    // We also turn on the flag to not reset the page

    if (role === "processor") {
      if (type === "Click") {
        // used to set row and col indexes to state for the use in click and capture time in pro (data update)
        setCellToUpdate({
          rowIndex: rowIndex,
          columnId: columnId,
        });
      }
      // in pro we are not storing mappjing instead storing value
      if (
        rowsData[rowIndex][columnId] === undefined ||
        (rowsData[rowIndex][columnId] &&
          rowsData[rowIndex][columnId].value !== value)
      ) {
        rowsData[rowIndex][columnId] = {
          ...rowsData[rowIndex][columnId],
          value: value,
          processor: localStorage?.userName,
          processedDate: moment(new Date()).format("MM-DD-YYYY"),
        };
        setRowsData([...rowsData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
      }
      // those cells which dont hav mapping by pre for which adding mapping in pro with value from above function
      if (
        (rowsData[rowIndex][columnId]?.pageNo === "" ||
          rowsData[rowIndex][columnId]?.pageNo === undefined) &&
        (rowsData[rowIndex][columnId]?.tagName === "" ||
          rowsData[rowIndex][columnId]?.tagName === undefined)
      ) {
        rowsData[rowIndex][columnId] = {
          ...rowsData[rowIndex][columnId],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
        };
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "freeform",
          category: "dataEntry",
          action: "Data Entry",
          pageNo: rowsData[rowIndex][columnId]?.pageNo,
          tagName: rowsData[rowIndex][columnId]?.tagName,
          fileNo: rowsData[rowIndex][columnId]?.fileNo,
          coordinates: rowsData[rowIndex][columnId]?.coordinates,
          coordinatesValues: rowsData[rowIndex][columnId]?.coordinatesValues,
          value: value,
          rowColIndex: [
            parseInt(rowIndex) + 1,
            parseInt(columnId.match(/\d+/)[0]),
          ],
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[parseInt(rowsData[rowIndex][columnId]?.fileNo)]
              ?.pages[parseInt(rowsData[rowIndex][columnId]?.pageNo)]?.imageUrl,
        }),
      ]);
    }
  };

  const rejectCell = ({ rejectionRemark, rowIndex, columnId }) => {
    if (role === "processor") {
      rowsData[rowIndex][columnId] = {
        ...rowsData[rowIndex][columnId],
        processorCellRejection: {
          isRejected: true,
          remark: rejectionRemark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      setProcessorsRejectionCounts((prev) => prev + 1);
    }
    if (role === "validator") {
      rowsData[rowIndex][columnId] = {
        ...rowsData[rowIndex][columnId],
        validatorCellRejection: {
          isRejected: true,
          remark: rejectionRemark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      setValidatorsRejectionCounts((prev) => prev + 1);
    }
    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Reject Cell",
        pageNo: rowsData[rowIndex][columnId]?.pageNo,
        tagName: rowsData[rowIndex][columnId]?.tagName,
        fileNo: rowsData[rowIndex][columnId]?.fileNo,
        coordinates: rowsData[rowIndex][columnId]?.coordinates,
        coordinatesValues: rowsData[rowIndex][columnId]?.coordinatesValues,
        value: rowsData[rowIndex][columnId]?.value,
        rowColIndex: [
          parseInt(rowIndex) + 1,
          parseInt(columnId.match(/\d+/)[0]),
        ],
        remark: rejectionRemark,
        mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[parseInt(rowsData[rowIndex][columnId]?.fileNo)]
            ?.pages[parseInt(rowsData[rowIndex][columnId]?.pageNo)]?.imageUrl,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);
  };

  const markAsResolveRejection = (parameterIndex, index) => {
    // In Pro ROle - mark rejection did by validator
    if (role === "processor") {
      rowsData[parameterIndex].validatorRowRejection = {
        isResolved: true,
        date: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark: rowsData[parameterIndex].validatorRowRejection?.remark,
      };
      setRowsData([...rowsData]);
      setValidatorsRejectionCounts((prev) => prev - 1);
    }
    if (role === "preProcessor") {
      rowsData[parameterIndex].processorRowRejection = {
        isResolved: true,
        resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark: rowsData[parameterIndex].processorRowRejection?.remark,
      };
      setRowsData([...rowsData]);
      setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "preProcessor" ? "mapping" : "dataEntry",
        action: "Resolved Row Rejection",
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
    setSkipPageReset(true);
  };

  const deleteRejection = ({ rowIndex, columnId }) => {
    if (role === "processor") {
      delete rowsData[rowIndex][columnId]["processorCellRejection"];
      setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (role === "validator") {
      delete rowsData[rowIndex][columnId]["validatorCellRejection"];
      setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement   counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Undo Cell Rejection",
        rowColIndex: [
          parseInt(rowIndex) + 1,
          parseInt(columnId.match(/\d+/)[0]),
        ],
      }),
    ]);
  };

  const handleRowRejection = (index, remark) => {
    if (role === "processor") {
      rowsData[index] = {
        ...rowsData[index],
        processorRowRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      setProcessorsRejectionCounts((prev) => prev + 1);
    }
    if (role === "validator") {
      rowsData[index] = {
        ...rowsData[index],
        validatorRowRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      setValidatorsRejectionCounts((prev) => prev + 1);
    }
    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Reject Row",
        rowColIndex: [parseInt(index) + 1],
        remark: remark,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);
  };

  const deleteRowRejection = (index) => {
    if (role === "processor") {
      delete rowsData[index]["processorRowRejection"];
      setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (role === "validator") {
      delete rowsData[index]["validatorRowRejection"];
      setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Undo Row Rejection",
        rowColIndex: [parseInt(index) + 1],
      }),
    ]);
  };

  const markAsResolveByProcessor = ({ rowIndex, columnId }) => {
    if (role === "preProcessor") {
      rowsData[rowIndex][columnId] = {
        ...rowsData[rowIndex][columnId],
        processorCellRejection: {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark: rowsData[rowIndex][columnId].processorCellRejection?.remark,
        },
      };
      setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (role === "processor") {
      rowsData[rowIndex][columnId] = {
        ...rowsData[rowIndex][columnId],
        validatorCellRejection: {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark: rowsData[rowIndex][columnId].validatorCellRejection?.remark,
        },
      };
      setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: role === "preProcessor" ? "mapping" : "dataEntry",
        action: "Resolved Cell Rejection",
        rowColIndex: [
          parseInt(rowIndex) + 1,
          parseInt(columnId.match(/\d+/)[0]),
        ],
        value: rowsData[rowIndex][columnId]?.value,
        pageNo: rowsData[rowIndex][columnId]?.pageNo,
        document:
          coordinatesData[parseInt(rowsData[rowIndex][columnId]?.fileNo)]
            ?.pages[parseInt(rowsData[rowIndex][columnId]?.pageNo)]?.imageUrl,
        mbrName: selectedFile?.originalFileName,
      }),
    ]);
    setSkipPageReset(true);
  };

  const onClickValidate = (action, parameterIndex) => {
    setSkipPageReset(true);
    if (action === "validate") {
      rowsData[parameterIndex]["rowValidation"] = {
        ...rowsData[parameterIndex]["rowValidation"],
        isValidated: true,
        validator: localStorage?.userName,
        date: moment(new Date()).format("DD-MMM-YYYY HH:mm:ss"),
      };

      const logs = [];

      for (const colKey in rowsData[parameterIndex]) {
        if (colKey.startsWith("col")) {
          const calculatedColIndex = parseInt(colKey.match(/\d+/)); // Match one or more digits
          const colData = rowsData[parameterIndex][colKey];
          logs.push(
            logObject({
              extractionType: "freeform",
              category: "validation",
              action: `Validate Cell`,
              pageNo: colData?.pageNo,
              tagName: colData?.tagName,
              fileNo: colData?.fileNo,
              coordinates: colData?.coordinates,
              coordinatesValues: colData?.coordinatesValues,
              value: colData?.value,
              rowColIndex: [parseInt(parameterIndex) + 1, calculatedColIndex],
              mbrName: selectedFile?.originalFileName,
              document:
                coordinatesData[
                  parseInt(rowsData[parameterIndex][colKey]?.fileNo)
                ]?.pages[parseInt(rowsData[parameterIndex][colKey]?.pageNo)]
                  ?.imageUrl,
            })
          );
        }
      }

      setLogs((prevLogs) => [...prevLogs, ...logs]);
    } else {
      rowsData[parameterIndex]["rowValidation"] = {};

      const logs = [];

      for (const colKey in rowsData[parameterIndex]) {
        if (colKey.startsWith("col")) {
          const calculatedColIndex = parseInt(colKey.match(/\d+/)); // Match one or more digits

          const colData = rowsData[parameterIndex][colKey];
          logs.push(
            logObject({
              extractionType: "freeform",
              category: "validation",
              action: `Undo Cell Validation`,
              pageNo: colData?.pageNo,
              tagName: colData?.tagName,
              fileNo: colData?.fileNo,
              coordinates: colData?.coordinates,
              coordinatesValues: colData?.coordinatesValues,
              value: colData?.value,
              rowColIndex: [parseInt(parameterIndex) + 1, calculatedColIndex],
              mbrName: selectedFile?.originalFileName,
              document:
                coordinatesData[
                  parseInt(rowsData[parameterIndex][colKey]?.fileNo)
                ]?.pages[parseInt(rowsData[parameterIndex][colKey]?.pageNo)]
                  ?.imageUrl,
            })
          );
        }
      }

      setLogs((prevLogs) => [...prevLogs, ...logs]);
    }
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  useEffect(() => {
    // This logic is used for pre pro role to add coordinates in cell wise when mapping data

    if (selectedArea) {
      setSkipPageReset(true);

      const coordinatesToAdd = selectedArea?.coords;
      const rowIndex = cellToUpdate?.rowIndex;
      const columnId = cellToUpdate?.columnId;

      if (
        selectedArea.coords &&
        rowIndex !== null &&
        rowIndex >= 0 &&
        columnId &&
        rowsData
      ) {
        if (cellToUpdate?.mappingFor === "parameterKey") {
          if (isDataRejectedByProcessor) {
            rowsData[rowIndex][columnId] = {
              ...rowsData[rowIndex][columnId],
              keyCoordinates: [
                ...rowsData[rowIndex][columnId]?.keyCoordinates,
                coordinatesToAdd,
              ],
              indexesOfCoordinates: [
                ...rowsData[rowIndex][columnId]?.indexesOfCoordinates,
                areaIndex,
              ],
            };
          } else {
            rowsData[rowIndex][columnId]["keyCoordinates"] = [
              ...rowsData[rowIndex][columnId]?.keyCoordinates,
              coordinatesToAdd,
            ];

            rowsData[rowIndex][columnId]["indexesOfCoordinates"] = [
              ...(rowsData[rowIndex][columnId]["indexesOfCoordinates"]
                ? [
                    ...rowsData[rowIndex][columnId]["indexesOfCoordinates"],
                    areaIndex,
                  ]
                : [areaIndex]),
            ];
          }

          // from be getting defficult to change payload so creating seperate array for values to show in cell menu
          if (
            rowsData[rowIndex][columnId]?.keyData &&
            rowsData[rowIndex][columnId]?.keyData?.tagName &&
            rowsData[rowIndex][columnId]?.keyData?.tagName !== "" &&
            rowsData[rowIndex][columnId]?.keyData &&
            rowsData[rowIndex][columnId]?.keyData?.pageNo >= 0
          ) {
            rowsData[rowIndex][columnId].keyCoordinatesValues = rowsData[
              rowIndex
            ][columnId].keyCoordinatesValues
              ? [
                  ...rowsData[rowIndex][columnId].keyCoordinatesValues,
                  selectedArea?.name,
                ]
              : [selectedArea?.name];
          }
        } else {
          // another
          if (isDataRejectedByProcessor) {
            rowsData[rowIndex][columnId] = {
              ...rowsData[rowIndex][columnId],
              coordinates: [
                ...rowsData[rowIndex][columnId]?.coordinates,
                coordinatesToAdd,
              ],
              indexesOfCoordinates: [
                ...rowsData[rowIndex][columnId]?.indexesOfCoordinates,
                areaIndex,
              ],
            };
          } else {
            rowsData[rowIndex][columnId]["coordinates"] = [
              ...rowsData[rowIndex][columnId]?.coordinates,
              coordinatesToAdd,
            ];

            rowsData[rowIndex][columnId]["indexesOfCoordinates"] = [
              ...(rowsData[rowIndex][columnId]["indexesOfCoordinates"]
                ? [
                    ...rowsData[rowIndex][columnId]["indexesOfCoordinates"],
                    areaIndex,
                  ]
                : [areaIndex]),
            ];
          }

          // from be getting defficult to change payload so creating seperate array for values to show in cell menu
          if (
            rowsData[rowIndex][columnId]?.tagName &&
            rowsData[rowIndex][columnId]?.tagName !== "" &&
            rowsData[rowIndex][columnId]?.pageNo >= 0
          ) {
            rowsData[rowIndex][columnId].coordinatesValues = rowsData[rowIndex][
              columnId
            ].coordinatesValues
              ? [
                  ...rowsData[rowIndex][columnId].coordinatesValues,
                  selectedArea?.name,
                ]
              : [selectedArea?.name];
          }
        }

        setRowsData([...rowsData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedArea]);

  // Let's add a data resetter/randomizer to help
  // illustrate that flow...
  const resetData = () => {
    setRowsData([{}, {}, {}, {}, {}]);
    addInitialColumns();
    setColumnsCount(0);
    setCellToUpdate({
      rowIndex: null,
      columnId: null,
    });
    resetPdfHeighlights();
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "mapping",
        action: "Reset Data",
      }),
    ]);
  };

  const resetDataApiCall = () => {
    dispatch(getProDataForReset());
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "inputs",
        action: "Reset Data",
      }),
    ]);
  };

  const clickAddRowChange = () => {
    const newRowsNo = !isNaN(rowInputRef.current.value)
      ? Number(rowInputRef.current.value)
      : 0;

    if (newRowsNo > 0) {
      for (let i = 0; i < newRowsNo; i++) {
        rowsData.push({});
      }
      setRowsData([...rowsData]);
      rowInputRef.current.value = "";
      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          isActivity: true,
          extractionType: "freeform",
          category: "inputs",
          action: "Add Rows",
          data: `${newRowsNo} - Rows added`,
        }),
      ]);
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);
  };

  const clickAddColumnChange = (callFrom) => {
    let noOfColToAdd;
    if (callFrom && callFrom === "moreRowCall") {
      noOfColToAdd = 1; // add one new column in state for add col in betn functionality and after adding column shifting columns values accordingly
    } else {
      noOfColToAdd = !isNaN(colInputRef.current.value)
        ? Number(colInputRef.current.value)
        : 0;
    }

    if (noOfColToAdd > 0) {
      let columnsFromState = columns;

      for (let i = 0; i < noOfColToAdd; i++) {
        let length = columnsFromState.length;

        columnsFromState.push({
          accessor: `col${length + 1}`,
          Header: headerAlphabetString(length + 1),
        });
      }

      setColumns([...columnsFromState]);
      setColumnsCount((prevCount) => prevCount + noOfColToAdd);
      colInputRef.current.value = "";

      if (callFrom === undefined) {
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            isActivity: true,
            extractionType: "freeform",
            category: "inputs",
            action: "Add Columns",
            data: `${noOfColToAdd} - Columns added`,
          }),
        ]);
      }
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setSkipPageReset(true);
  };

  const addColInBetween = (id, pos, column) => {
    if (pos === "before") {
      clickAddColumnChange("moreRowCall"); // to add new col
      const cellToBeAddDigitNo = parseInt(id.match(/\d+/)[0]);
      const tempRowsData = rowsData;
      const newRowsData = [];

      tempRowsData.map((item, index) => {
        // sgifting logic
        const orgData = { ...item };
        [...Array(columns?.length).keys()].map((index) => {
          if (index + 1 >= cellToBeAddDigitNo) {
            orgData[`col${index + 2}`] = item[`col${index + 1}`];
          }
        });
        delete orgData[id];

        newRowsData.push(orgData);
      });

      setRowsData([...newRowsData]);
    } else if (pos === "after") {
      let cellToBeAdd = `col${parseInt(id.match(/\d+/)[0]) + 1}`;
      clickAddColumnChange("moreRowCall"); // to add new col
      const cellToBeAddDigitNo = parseInt(cellToBeAdd.match(/\d+/)[0]);
      const tempRowsData = rowsData;
      const newRowsData = [];

      tempRowsData.map((item, index) => {
        // sgifting logic
        const orgData = { ...item };
        [...Array(columns?.length).keys()].map((index) => {
          if (index + 1 >= cellToBeAddDigitNo) {
            orgData[`col${index + 2}`] = item[`col${index + 1}`];
          }
        });
        delete orgData[cellToBeAdd];

        newRowsData.push(orgData);
      });
      setRowsData([...newRowsData]);
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    let leftOrRightVal = pos === "before" ? "left" : "right";
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "inputs",
        action: `Column Insert In Between`,
        data: `Column inserted to ${leftOrRightVal} from original column ${column}`,
      }),
    ]);

    setSkipPageReset(true);
  };

  const deleteColumn = (colIdTODelete, column) => {
    const tempRowsData = rowsData;
    const newRowsData = [];
    let columnsFromState = columns;

    const cellToBeDeleteDigitNo = parseInt(colIdTODelete.match(/\d+/)[0]);

    tempRowsData.map((item, index) => {
      const orgData = { ...item };
      [...Array(columns?.length).keys()].map((index) => {
        if (index + 1 >= cellToBeDeleteDigitNo) {
          orgData[`col${index + 1}`] = item[`col${index + 2}`];
        }
      });

      newRowsData.push(orgData);
    });
    setRowsData([...newRowsData]);

    columnsFromState.pop();

    setColumns([...columns]);
    setColumnsCount((prevCount) => prevCount - 1);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "inputs",
        action: `Delete Column`,
        data: `Column ${column} deleted`,
      }),
    ]);

    setSkipPageReset(true);
  };

  const addRowsInBetween = (id, pos) => {
    if (pos === "above") {
      rowsData.splice(parseInt(id), 0, {});
    } else if (pos === "below") {
      let index = parseInt(id) + 1;
      rowsData.splice(index, 0, {});
    }
    setRowsData([...rowsData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "inputs",
        action: `Insert Row`,
        data: `Row inserted to ${pos} from original row ${parseInt(id) + 1}`,
      }),
    ]);
    setSkipPageReset(true);
  };

  const deleteRow = (rowIdToDelete) => {
    const data = rowsData;
    data.splice(parseInt(rowIdToDelete), 1);
    setRowsData([...data]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "freeform",
        category: "inputs",
        action: `Delete Row`,
        data: `Row number ${parseInt(rowIdToDelete) + 1} deleted`,
      }),
    ]);

    setSkipPageReset(true);
  };

  const updateDataUsingManuallyContextMenu = (
    rowIndex,
    columnId,
    dragToValues
  ) => {
    if (
      rowsData[rowIndex][columnId] &&
      rowsData[rowIndex][columnId]?.value &&
      rowsData[rowIndex][columnId]?.value !== undefined
    ) {
      let selectedCellvalueToFill = rowsData[rowIndex][columnId];
      let noOfSelectedCol = columnId.match(/\d+/)[0];

      if (dragToValues?.pos === "right") {
        const totColumnsFromState = columns;
        // finding remeaninng size col columns by extraction current col number
        const exceptCurrentColRemeaningColslength =
          totColumnsFromState.length - noOfSelectedCol;

        for (
          let i = 1;
          i <= Math.min(exceptCurrentColRemeaningColslength, dragToValues?.nos);
          i++
        ) {
          const nextColIdToFill = parseInt(noOfSelectedCol) + i;
          const nextColId = `col${nextColIdToFill}`;
          rowsData[rowIndex][nextColId] = selectedCellvalueToFill;
        }
        setRowsData([...rowsData]);
      }

      if (dragToValues?.pos === "left") {
        // finding remeaninng size col columns by extraction current col number
        const exceptCurrentColRemeaningColslength = noOfSelectedCol - 1;

        for (
          let i = 1;
          i <= Math.min(exceptCurrentColRemeaningColslength, dragToValues?.nos);
          i++
        ) {
          const prevColIdToFill = parseInt(noOfSelectedCol) - i;
          const prevColId = `col${prevColIdToFill}`;
          rowsData[rowIndex][prevColId] = selectedCellvalueToFill;
        }
        setRowsData([...rowsData]);
      }

      if (dragToValues?.pos === "above") {
        // in below func tme remained row is same as rowIndex because it shows up to yet remeaning rows
        for (let i = 1; i <= Math.min(rowIndex, dragToValues?.nos); i++) {
          const nextColIdToFill = parseInt(rowIndex) - i;
          rowsData[nextColIdToFill][columnId] = selectedCellvalueToFill;
        }
        setRowsData([...rowsData]);
      }

      if (dragToValues?.pos === "below") {
        const totRowsFromState = rowsData;

        const exceptCurrentRowRemeaningRowslength =
          totRowsFromState.length - 1 - rowIndex;

        for (
          let i = 1;
          i <= Math.min(exceptCurrentRowRemeaningRowslength, dragToValues?.nos);
          i++
        ) {
          const nextRowIdToFill = parseInt(rowIndex) + i;
          rowsData[nextRowIdToFill][columnId] = selectedCellvalueToFill;
        }
        setRowsData([...rowsData]);
      }
      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          isActivity: true,
          extractionType: "freeform",
          category: "inputs",
          action: `Copied Data Using Context menu`,
          data: `Row ${rowIndex} of column ${parseInt(
            columnId.match(/\d+/)[0]
          )} copied to ${dragToValues?.pos} ${dragToValues?.nos} cells`,
        }),
      ]);
    }
    setSkipPageReset(true);
  };

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  React.useEffect(() => {
    setSkipPageReset(false);
  }, [rowsData]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setAlert({ ...isAlert, open: false, message: "", title: "" });
    }

    setAlert({ ...isAlert, open: false, message: "", title: "" });
  };

  const clearMappings = (parameterIndex, mappingIndex, type) => {
    let oldKeyData = {
      tagName: "",
      pageNo: "",
      fileNo: "",
      preProcessor: localStorage.userName,
      preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    };

    if (type === "toResetKeyMapping") {
      let cellData = {
        ...rowsData[parameterIndex][mappingIndex],
        keyCoordinates: [],
        keyCoordinatesValues: [],
        keyData: oldKeyData,
      };
      rowsData[parameterIndex][mappingIndex] = cellData;
      setRowsData([...rowsData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "freeform",
          category: role === "preProcessor" ? "mapping" : "dataEntry",
          action: "Reset Key Mapping",
          coordinates: rowsData[parameterIndex][mappingIndex]?.coordinates,
          coordinatesValues:
            rowsData[parameterIndex][mappingIndex]?.coordinatesValues,
          tagName: rowsData[parameterIndex][mappingIndex]?.tagName,
          pageNo: rowsData[parameterIndex][mappingIndex]?.pageNo,
          fileNo: rowsData[parameterIndex][mappingIndex]?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex.match(/\d+/)[0]),
          ],
          value: `${cellData?.tagName} - ${
            cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
          }`,
          mbrName: selectedFile?.originalFileName,
          document:
            role === "preProcessor"
              ? ""
              : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
                  ?.imageUrl,
          keyCoordinates: [],
          keyCoordinatesValues: [],
          keyData: oldKeyData,
        }),
      ]);
    } else if (type === "toResetValueMapping") {
      let cellData = {
        ...rowsData[parameterIndex][mappingIndex],
        value: "",
        tagName:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.tagName
            ? selectedFilesDataForProUpdate?.tagName
            : "",
        pageNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.pageNo >= 0
              ? selectedFilesDataForProUpdate?.pageNo
              : "",
        fileNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.fileNo >= 0
              ? selectedFilesDataForProUpdate?.fileNo
              : "",
        coordinates: [],
        coordinatesValues: [],
        ...(role === "preProcessor" && {
          preProcessor: localStorage.userName,
          preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
        ...(role === "processor" && {
          processor: localStorage.userName,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
      };
      rowsData[parameterIndex][mappingIndex] = cellData;
      setRowsData([...rowsData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "freeform",
          category: role === "preProcessor" ? "mapping" : "dataEntry",
          action: "Reset Value Mapping",
          coordinates: rowsData[parameterIndex][mappingIndex]?.coordinates,
          coordinatesValues:
            rowsData[parameterIndex][mappingIndex]?.coordinatesValues,
          tagName: rowsData[parameterIndex][mappingIndex]?.tagName,
          pageNo: rowsData[parameterIndex][mappingIndex]?.pageNo,
          fileNo: rowsData[parameterIndex][mappingIndex]?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex.match(/\d+/)[0]),
          ],
          value: `${cellData?.tagName} - ${
            cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
          }`,
          mbrName: selectedFile?.originalFileName,
          document:
            role === "preProcessor"
              ? ""
              : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
                  ?.imageUrl,
        }),
      ]);
    } else if (type === "toResetKeyValueMapping") {
      let cellData = {
        ...rowsData[parameterIndex][mappingIndex],
        value: "",
        tagName:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.tagName
              ? selectedFilesDataForProUpdate?.tagName
              : "",
        pageNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.pageNo >= 0
              ? selectedFilesDataForProUpdate?.pageNo
              : "",
        fileNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.fileNo >= 0
              ? selectedFilesDataForProUpdate?.fileNo
              : "",
        coordinates: [],
        coordinatesValues: [],
        ...(role === "preProcessor" && {
          preProcessor: localStorage.userName,
          preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
        ...(role === "processor" && {
          processor: localStorage.userName,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
        keyCoordinates: [],
        keyCoordinatesValues: [],
        keyData: oldKeyData,
      };
      rowsData[parameterIndex][mappingIndex] = cellData;
      setRowsData([...rowsData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "freeform",
          category: role === "preProcessor" ? "mapping" : "dataEntry",
          action: "Reset Key And Value Mapping",
          coordinates: rowsData[parameterIndex][mappingIndex]?.coordinates,
          coordinatesValues:
            rowsData[parameterIndex][mappingIndex]?.coordinatesValues,
          tagName: rowsData[parameterIndex][mappingIndex]?.tagName,
          pageNo: rowsData[parameterIndex][mappingIndex]?.pageNo,
          fileNo: rowsData[parameterIndex][mappingIndex]?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex.match(/\d+/)[0]),
          ],
          value: `${cellData?.tagName} - ${
            cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
          }`,
          mbrName: selectedFile?.originalFileName,
          document:
            role === "preProcessor"
              ? ""
              : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
                  ?.imageUrl,
          keyCoordinates: [],
          keyCoordinatesValues: [],
          keyData: oldKeyData,
        }),
      ]);
    }

    setSkipPageReset(true);
  };

  const addLogsForMappingOnBlur = (rowIndex, mappingIndex, string) => {
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "freeform",
        category: "mapping",
        action:
          string === "valueMapping"
            ? "Add Value Mapping"
            : "Add Parameter Key Mapping",
        coordinates:
          string === "valueMapping"
            ? rowsData[rowIndex][mappingIndex]?.coordinates
            : rowsData[rowIndex][mappingIndex]?.parameterKeyCoordinates,
        coordinatesValues:
          string === "valueMapping"
            ? rowsData[rowIndex][mappingIndex]?.coordinatesValues
            : rowsData[rowIndex][mappingIndex]?.parameterKeycoordinatesValues,
        tagName: rowsData[rowIndex][mappingIndex]?.tagName,
        pageNo: rowsData[rowIndex][mappingIndex]?.pageNo,
        fileNo: rowsData[rowIndex][mappingIndex]?.fileNo,
        rowColIndex: [
          parseInt(rowIndex) + 1,
          parseInt(mappingIndex.match(/\d+/)[0]),
        ],
        mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
            ?.imageUrl,
      }),
    ]);

    setSkipPageReset(true);
  };

  return (
    <Box>
      {showParameterTable && (
        <Styles className="CNCTable">
          {/* <Prompt
        when={anyOperationPerformedOnEntirePage.current}
        message="Changes that you made may not be saved."
      /> */}
          {/* <Prompt when={anyOperationPerformedOnEntirePage.current} /> */}

          {role !== "validator" && (
            <>
              <FormControl className="custom-row-columns">
                <Input
                  inputRef={rowInputRef}
                  type="number"
                  inputProps={{
                    min: "0",
                  }}
                  placeholder={"Add Rows"}
                  id="row"
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      clickAddRowChange();
                    }
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(e) => clickAddRowChange()}
                        type="submit"
                      >
                        <AddCircleTwoToneIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              <FormControl className="custom-row-columns">
                <Input
                  inputRef={colInputRef}
                  type="number"
                  inputProps={{
                    min: "0",
                  }}
                  placeholder={"Add Columns"}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      clickAddColumnChange();
                    }
                  }}
                  id="col"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(e) => clickAddColumnChange()}
                      >
                        <AddCircleTwoToneIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {role === "preProcessor" && (
                <Button onClick={resetData} className="reset-btn">
                  Reset Data
                </Button>
              )}

              {role === "processor" && (
                <Button onClick={resetDataApiCall} className="reset-btn">
                  Reset Data
                </Button>
              )}
            </>
          )}
          <Table
            columns={columns}
            data={rowsData}
            updateMyData={updateMyData}
            setCellToUpdateToState={setCellToUpdateToState}
            skipPageReset={skipPageReset}
            // extra props

            addColInBetween={addColInBetween}
            deleteColumn={deleteColumn}
            addRowsInBetween={addRowsInBetween}
            deleteRow={deleteRow}
            updateDataUsingManuallyContextMenu={
              updateDataUsingManuallyContextMenu
            }
            anyOperationPerformedOnEntirePage={
              anyOperationPerformedOnEntirePage
            }
            // extra props

            showContextMenu={showContextMenu}
            isDisableOnChangeInput={isDisableOnChangeInput}
            isDisableOnBlur={isDisableOnBlur}
            role={role}
            //rejection
            rejectCell={rejectCell}
            deleteRejection={deleteRejection}
            markAsResolveByProcessor={markAsResolveByProcessor}
            handleRowRejection={handleRowRejection}
            deleteRowRejection={deleteRowRejection}
            reProcess={reProcess}
            reValidate={reValidate}
            isDataRejectedByProcessor={isDataRejectedByProcessor}
            isDataRejectedByValidator={isDataRejectedByValidator}
            onClickValidate={onClickValidate}
            markAsResolveRejection={markAsResolveRejection}
            // isFullView={isFullView}
            clearMappings={clearMappings}
            entireBatchRejectedByPro={entireBatchRejectedByPro}
            entireBatchRejectedByVali={entireBatchRejectedByVali}
            reProcessEntireBatch={reProcessEntireBatch}
            addLogsForMappingOnBlur={addLogsForMappingOnBlur}
            resestSelectedArea={resestSelectedArea}
          />

          {isAlert?.open && (
            <Snackbar
              open={true}
              autoHideDuration={3000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              key={"top" + "center"}
            >
              <Alert
                onClose={handleClose}
                className="error-alert"
                severity="error"
              >
                <AlertTitle color="white">{isAlert?.title}</AlertTitle>
                {isAlert?.message}
              </Alert>
            </Snackbar>
          )}
          {openAuth && (
            <Authentication
              openAuth={openAuth}
              handleClose={handleCloseAuth}
              handleUserPermission={handleUserPermission}
            />
          )}
          {openSignPad && (
            <ModalSign
              openSignPad={openSignPad}
              handleEsignDialogBoxClose={handleCloseSignPad}
            ></ModalSign>
          )}
        </Styles>
      )}
    </Box>
  );
});

CNCTableWrapper.defaultProps = {};

export default CNCTableWrapper;
